<app-datatable
  [dataSourceUrl]="dtDataSourceUrl"
  [settings]="dtSettings"
  (onInit)="onDtInit($event)"
  (onAction)="this.onAction($event)">
  <th class="column-hide" data-data="id">Id</th>
  <th data-data="fullName">Név</th>
  <th data-data="email">E-mail cím</th>
  <th data-data="roles">Szerepkörök</th>
  <th class="datetime" data-data="lastLoginDateUtc">Utolsó bejelentkezés</th>
  <th data-data="status">Státusz</th>
  <th class="column-actions">Műveletek</th>
</app-datatable>
